module.exports = __webpack_public_path__ + "static/img/pic_wenduyc.c8842ac3.png";